import { useTranslation } from "react-i18next";
import { Descriptions } from "antd";

import View from "components/elements/View";
import useUserData from "hooks/useUserData";

function UserInfo(): JSX.Element {
  const { t } = useTranslation();
  const userData = useUserData();

  return (
    <View title={t("user_info.title")}>
      <Descriptions>
        <Descriptions.Item label={t("user_info.labels.name")}>
          {userData?.name}
        </Descriptions.Item>
        <Descriptions.Item label={t("user_info.labels.email")}>
          {userData?.email}
        </Descriptions.Item>
        <Descriptions.Item label={t("user_info.labels.roles")}>
          {userData?.roles.join(" - ")}
        </Descriptions.Item>
      </Descriptions>
    </View>
  );
}

export default UserInfo;
